<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Create Redirect</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Source *</label>
                  <div class="col-md-10">
                    <input
                      id="source"
                      v-model="entity.source"
                      type="text"
                      placeholder="Enter source"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Destination *</label>
                  <div class="col-md-10">
                    <input
                      id="destination"
                      v-model="entity.destination"
                      type="text"
                      placeholder="Enter destination"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Redirect has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'RedirectsNew',

  mixins: [CreatePageMixin],

  data() {
    return {
      entity: {
        source: null,
        destination: null,
      },
    };
  },

  methods: {
    isEntityValid() {
      if (!this.entity.source) {
        this.$_showError('Source field is required');
        return false;
      }
      if (!this.entity.destination) {
        this.$_showError('Destination field is required');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('source', this.entity.source);
      postFormData.append('destination', this.entity.destination);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}redirects`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/redirects/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create redirect query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?e63d8196